const formatResult = (result: string) => result.replace("1/2-1/2", "½-½")

export default formatResult
